module.exports = __webpack_public_path__ + "img/veloster.46cb9bc3.png";